module.exports = __webpack_public_path__ + "static/media/Draw.e7fbf66d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Draw.png
// module id = 192
// module chunks = 0